var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"div-main"},[_c('div',{staticClass:"div-content mt-3"},[_c('el-image',{attrs:{"src":"img/ProgressWorking.png","fit":"cover"}})],1),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-3 text-center"},[_c('h1',[_vm._v("Đang phát triển")])])
}]

export { render, staticRenderFns }